import { useEffect, useRef } from "react";

export default function PlayerIframe({
  type = "", // song or empty
  id,
  refresh = 0,
  cache = true,
  width = "100%",
}) {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (refresh === 0) {
      return;
    }

    const iframe = iframeRef.current;
    iframe.src = iframe.src;
  }, [refresh]);

  return (
    <iframe
      title="Player"
      src={`/player/embed/${type}/${id}?cache=${cache}`}
      width={width}
      height={type === "song" ? "287" : "500"}
      frameBorder="0"
      allow="autoplay; fullscreen; encrypted-media"
      ref={iframeRef}
    ></iframe>
  );
}
